// extracted by mini-css-extract-plugin
module.exports = {"link":"BannerBackgroundLinkWrapper_link__dD8_R"};